import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PLAN_LABELS = { 'essentiel-yearly': 'Essentiel (annuel)', 'pro-yearly': 'Impact (annuel)', 'organisation-yearly': 'Organisation (annuel)', 'essentiel-monthly': 'Essentiel (mensuel)', 'pro-monthly': 'Impact (mensuel)', 'organisation-monthly': 'Organisation (mensuel)' };

export default function BillingCancel() {
    const [params] = useSearchParams();
    const plan = params.get('plan');
    const label = PLAN_LABELS[plan] || 'votre plan';

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
            <div className="max-w-md w-full card-soft p-10 text-center" data-testid="billing-cancel-page">
                <div className="h-16 w-16 rounded-full bg-amber-50 text-amber-600 mx-auto flex items-center justify-center mb-5">
                    <XCircle size={32} />
                </div>
                <h1 className="font-heading text-2xl mb-3">Paiement annulé</h1>
                <p className="text-foreground/70 mb-6 leading-relaxed">
                    Vous avez interrompu le paiement de <strong>{label}</strong>. Aucune somme n'a été débitée.
                </p>
                <div className="flex flex-col gap-2.5">
                    <Link to="/#pricing">
                        <Button className="w-full bg-primary hover:bg-primary-hover">Revenir aux tarifs</Button>
                    </Link>
                    <Link to="/" className="text-xs text-foreground/55 hover:text-foreground mt-2">
                        ← Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
}
